var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-delete": false,
          "show-new": false,
          "show-save": false,
          "show-cancel": false,
          title: _vm.productionObj[_vm.filter.jobInOut],
          "show-print": true,
        },
        on: { appDetailHeaderButtonClicked: _vm.print },
      }),
      _c("div", { staticClass: "tile is-ancestor is-parent" }, [
        _c(
          "div",
          { staticClass: "tile is-vertical is-parent" },
          [
            _c("production-in-out-menu-bar", {
              attrs: {
                "is-loading": _vm.isLoading,
                data: _vm.entitySummaries,
                days: _vm.groupEntitySummaries.length,
                "total-jobs": _vm.totalRows,
                "include-gst": _vm.includeGst,
              },
              on: { "filter-list": _vm.filterList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
            _vm.groupEntitySummaries.length > 0
              ? _c(
                  "div",
                  { staticClass: "tile is-child box p-1" },
                  _vm._l(
                    _vm.groupEntitySummaries,
                    function (entity, entityIndex) {
                      return _c(
                        "div",
                        { key: entityIndex, staticClass: "column" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "columns has-text-primary has-text-weight-bold mt-0 mb-1 p-0",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "column is-one-fifths ml-2 p-1",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.dateHeaderClick(
                                            _vm.filter.sortColumn
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(_vm._s(entity.date) + " "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.filter.sortColumn ===
                                                "JobInOutDate",
                                              expression:
                                                "filter.sortColumn === 'JobInOutDate'",
                                            },
                                          ],
                                          staticClass: "icon is-small",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi",
                                            class:
                                              _vm.filter.sortOrder === "asc"
                                                ? "mdi-chevron-double-up"
                                                : "mdi-chevron-double-down",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "column is-one-fifths p-1" },
                                [
                                  _c("span", [_vm._v("Total Jobs: ")]),
                                  _c("span", [
                                    _vm._v(_vm._s(entity.jobs.length)),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "column is-one-fifths p-1" },
                                [
                                  _c("span", [_vm._v("Total Amount: ")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          entity.subtotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c("div", {
                            staticClass: "is-divider divider-color m-0",
                          }),
                          _c(
                            "bulma-table",
                            {
                              key: entity.date,
                              staticClass:
                                "table is-striped is-narrow is-fullwidth is-hoverable",
                              attrs: {
                                columns: _vm.columns,
                                "total-rows": _vm.entitySummaries.length,
                                "is-loading": _vm.isLoading,
                                "sort-column": _vm.filter.sortColumn,
                                "sort-order": _vm.filter.sortOrder,
                                "show-pagination": false,
                              },
                              on: { sort: _vm.sort },
                            },
                            _vm._l(entity.jobs, function (job, index) {
                              return _c(
                                "tr",
                                {
                                  key: job.quoteId,
                                  class: {
                                    "is-selected": _vm.selectedRow === index,
                                  },
                                },
                                [
                                  _c("td", { staticClass: "col-1" }, [
                                    _vm._v(_vm._s(index + 1)),
                                  ]),
                                  _c("td", { staticClass: "col-5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatTimeLocale(
                                          job.jobInOutDate,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "col-10" }, [
                                    _vm._v(_vm._s(job.jobStageDesc)),
                                  ]),
                                  _c("td", { staticClass: "col-5" }, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.quoteClick(job.quoteId)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(job.quoteNoRef))]
                                    ),
                                  ]),
                                  _c("td", { staticClass: "col-10" }, [
                                    _vm._v(_vm._s(job.owner)),
                                  ]),
                                  _c("td", { staticClass: "col-5" }, [
                                    _vm._v(_vm._s(job.rego)),
                                  ]),
                                  _c("td", { staticClass: "col-10" }, [
                                    _vm._v(_vm._s(job.makeModel)),
                                  ]),
                                  _c("td", { staticClass: "col-10" }, [
                                    _vm._v(_vm._s(job.insurer)),
                                  ]),
                                  _vm.filter.jobInOut === 0
                                    ? _c("td", { staticClass: "col-10" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$filters.formatDateTimeLocale(
                                              job.jobEnd,
                                              _vm.$userInfo.locale
                                            )
                                          ) + " "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.filter.jobInOut === 0
                                    ? _c(
                                        "td",
                                        {
                                          staticClass:
                                            "has-text-centered col-8",
                                        },
                                        [_vm._v(_vm._s(job.daysBooked))]
                                      )
                                    : _vm._e(),
                                  _vm.filter.jobInOut === 1
                                    ? _c(
                                        "td",
                                        { staticClass: "has-text-right col-8" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.formatNumber(
                                                job.ownersContribution,
                                                _vm.$userInfo.locale
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.$user.hasEdit(_vm.$route.meta.id)
                                    ? _c(
                                        "td",
                                        { staticClass: "has-text-right col-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.formatNumber(
                                                job.totalIncGst,
                                                _vm.$userInfo.locale
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    { staticClass: "has-text-centered col-1" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-dark is-small is-inverted",
                                          on: {
                                            mouseover: function ($event) {
                                              return _vm.getNotesContent(
                                                job.isNoteExists,
                                                job.quoteId
                                              )
                                            },
                                            mouseout: function ($event) {
                                              return _vm.resetNotesContent()
                                            },
                                            click: function ($event) {
                                              return _vm.notesClick(
                                                job.quoteId,
                                                job.quoteNoRef
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "tippy",
                                                  rawName: "v-tippy",
                                                  value: {
                                                    enabled:
                                                      _vm.showNoteContent,
                                                    placement: "left-start",
                                                    arrow: false,
                                                    allowHTML: true,
                                                  },
                                                  expression:
                                                    "{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }",
                                                },
                                              ],
                                              staticClass: "icon is-medium",
                                              attrs: {
                                                content: _vm.notesContent,
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "mdi mdi-24px",
                                                class: [
                                                  job.isNoteExists
                                                    ? "mdi-note-edit has-text-warning"
                                                    : "mdi-note-edit-outline has-text-grey",
                                                ],
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "has-text-centered col-1" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-dark is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.vehicleClick(
                                                job.quoteId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass: "mdi mdi-32px",
                                                class: [
                                                  (
                                                    _vm.filter.jobInOut === 0
                                                      ? job.arrivedForRepairDate
                                                      : job.vehicleDepartedDate
                                                  )
                                                    ? "mdi-car-side has-text-success"
                                                    : "mdi-car-side has-text-grey",
                                                ],
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _vm.entitySummaries.length === 0 && !_vm.isLoading
              ? _c(
                  "div",
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-striped is-narrow is-fullwidth is-hoverable",
                        attrs: {
                          columns: _vm.columns,
                          "show-pagination": false,
                        },
                      },
                      [
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { ref: "notesList", staticClass: "is-hidden" }, [
        _c(
          "ul",
          {
            staticStyle: { "list-style-type": "disc", "padding-left": "1rem" },
          },
          _vm._l(_vm.notes, function (note, index) {
            return _c("li", { key: index }, [
              _c("span", { staticClass: "is-size-6" }, [
                _vm._v(_vm._s(note.remarks)),
              ]),
              _c(
                "div",
                { staticClass: "is-flex is-align-items-center is-size-7" },
                [
                  note.firstName || note.displayName
                    ? _c("user-profile-icon", {
                        staticClass: "pr-1",
                        attrs: {
                          "is-text-profile": true,
                          "first-name": note.firstName,
                          "last-name": note.lastName,
                          "display-name": note.displayName,
                          width: 20,
                          height: 20,
                        },
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "help is-italic has-text-grey" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatDateTimeLocale(
                          note.remarkDateTime,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
      _vm.isNoteModalActive
        ? _c("note-modal", {
            attrs: {
              active: _vm.isNoteModalActive,
              "quote-id": _vm.selectedQuoteId,
              "job-no": _vm.selectedJobNo,
              "remark-type": _vm.remarkType,
              "remark-desc": _vm.remarkDesc,
            },
            on: {
              "update:active": function ($event) {
                _vm.isNoteModalActive = $event
              },
              close: _vm.closeNoteModal,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }